// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  bottom: 4%;
  right: 2%;
  width: 50px;
  height: 50px;
  background-color: var(--default);
  border-radius: 0.25rem;
  box-shadow: 0px 0px 3px #b7b7b9;
  z-index: 9999;
}
:host .sk-folding-cube {
  margin: 18px auto;
  width: 15px;
  height: 15px;
  position: relative;
  transform: rotateZ(45deg);
}
:host .sk-folding-cube .sk-cube {
  float: left;
  width: 50%;
  height: 50%;
  position: relative;
  transform: scale(1.1);
}
:host .sk-folding-cube .sk-cube:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--tablue);
  animation: sk-foldCubeAngle 2.4s infinite linear both;
  transform-origin: 100% 100%;
}
:host .sk-folding-cube .sk-cube2 {
  transform: scale(1.1) rotateZ(90deg);
}
:host .sk-folding-cube .sk-cube3 {
  transform: scale(1.1) rotateZ(180deg);
}
:host .sk-folding-cube .sk-cube4 {
  transform: scale(1.1) rotateZ(270deg);
}
:host .sk-folding-cube .sk-cube2:before {
  animation-delay: 0.3s;
}
:host .sk-folding-cube .sk-cube3:before {
  animation-delay: 0.6s;
}
:host .sk-folding-cube .sk-cube4:before {
  animation-delay: 0.9s;
}
@keyframes sk-foldCubeAngle {
  0%, 10% {
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  }
  25%, 75% {
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  }
  90%, 100% {
    transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,sBAAA;EACA,+BAAA;EACA,aAAA;AACJ;AACI;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,yBAAA;AACR;AAEI;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EAGA,qBAAA;AAAR;AAGI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EAEA,qDAAA;EAGA,2BAAA;AADR;AAII;EAEI,oCAAA;AAFR;AAKI;EAEI,qCAAA;AAHR;AAMI;EAEI,qCAAA;AAJR;AAOI;EAEI,qBAAA;AALR;AAQI;EAEI,qBAAA;AANR;AASI;EAEI,qBAAA;AAPR;AAkCI;EAEI;IAGI,8CAAA;IACA,UAAA;EAjBV;EAoBM;IAGI,2CAAA;IACA,UAAA;EAnBV;EAsBM;IAGI,6CAAA;IACA,UAAA;EArBV;AACF","sourcesContent":[":host {\n    position: fixed;\n    bottom: 4%;\n    right: 2%;\n    width: 50px;\n    height: 50px;\n    background-color: var(--default);\n    border-radius: .25rem;\n    box-shadow: 0px 0px 3px #b7b7b9;\n    z-index: 9999;\n\n    .sk-folding-cube {\n        margin: 18px auto;\n        width: 15px;\n        height: 15px;\n        position: relative;\n        -webkit-transform: rotateZ(45deg);\n        transform: rotateZ(45deg);\n    }\n\n    .sk-folding-cube .sk-cube {\n        float: left;\n        width: 50%;\n        height: 50%;\n        position: relative;\n        -webkit-transform: scale(1.1);\n        -ms-transform: scale(1.1);\n        transform: scale(1.1);\n    }\n\n    .sk-folding-cube .sk-cube:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: var(--tablue);\n        -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;\n        animation: sk-foldCubeAngle 2.4s infinite linear both;\n        -webkit-transform-origin: 100% 100%;\n        -ms-transform-origin: 100% 100%;\n        transform-origin: 100% 100%;\n    }\n\n    .sk-folding-cube .sk-cube2 {\n        -webkit-transform: scale(1.1) rotateZ(90deg);\n        transform: scale(1.1) rotateZ(90deg);\n    }\n\n    .sk-folding-cube .sk-cube3 {\n        -webkit-transform: scale(1.1) rotateZ(180deg);\n        transform: scale(1.1) rotateZ(180deg);\n    }\n\n    .sk-folding-cube .sk-cube4 {\n        -webkit-transform: scale(1.1) rotateZ(270deg);\n        transform: scale(1.1) rotateZ(270deg);\n    }\n\n    .sk-folding-cube .sk-cube2:before {\n        -webkit-animation-delay: 0.3s;\n        animation-delay: 0.3s;\n    }\n\n    .sk-folding-cube .sk-cube3:before {\n        -webkit-animation-delay: 0.6s;\n        animation-delay: 0.6s;\n    }\n\n    .sk-folding-cube .sk-cube4:before {\n        -webkit-animation-delay: 0.9s;\n        animation-delay: 0.9s;\n    }\n\n    @-webkit-keyframes sk-foldCubeAngle {\n\n        0%,\n        10% {\n            -webkit-transform: perspective(140px) rotateX(-180deg);\n            transform: perspective(140px) rotateX(-180deg);\n            opacity: 0;\n        }\n\n        25%,\n        75% {\n            -webkit-transform: perspective(140px) rotateX(0deg);\n            transform: perspective(140px) rotateX(0deg);\n            opacity: 1;\n        }\n\n        90%,\n        100% {\n            -webkit-transform: perspective(140px) rotateY(180deg);\n            transform: perspective(140px) rotateY(180deg);\n            opacity: 0;\n        }\n    }\n\n    @keyframes sk-foldCubeAngle {\n\n        0%,\n        10% {\n            -webkit-transform: perspective(140px) rotateX(-180deg);\n            transform: perspective(140px) rotateX(-180deg);\n            opacity: 0;\n        }\n\n        25%,\n        75% {\n            -webkit-transform: perspective(140px) rotateX(0deg);\n            transform: perspective(140px) rotateX(0deg);\n            opacity: 1;\n        }\n\n        90%,\n        100% {\n            -webkit-transform: perspective(140px) rotateY(180deg);\n            transform: perspective(140px) rotateY(180deg);\n            opacity: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
